import {SUSCRIPCION_TYPES} from '../constants/suscripcion.types'
import {Suscripcion, SuscripcionAction, SuscripcionState} from '../interfaces/suscripcion.interface'

const initialState: Suscripcion = {
  datosSuscripcion: null,
  suscripciones: [],
  suscripcionesFiltradas: [],
  seleccion: null,
  detallePago: null,
  validarSaldo: false,
  formFechas: {
    inicio: '',
    fin: '',
  },
}

const suspcripcionReducer = (
  state: SuscripcionState = initialState,
  action: SuscripcionAction
): SuscripcionState => {
  const {type, payload} = action
  switch (type) {
    case SUSCRIPCION_TYPES.SUSCRIPCION_SET_DATOS_SUSCRIPCION:
      return {...state, datosSuscripcion: payload}
    case SUSCRIPCION_TYPES.SUSCRIPCION_SET_SUSCRIPCIONES:
      return {...state, suscripciones: payload}
    case SUSCRIPCION_TYPES.SUSCRIPCION_SET_SUSCRIPCIONES_FILTRADAS:
      return {...state, suscripcionesFiltradas: payload}
    case SUSCRIPCION_TYPES.SUSCRIPCION_SET_SELECCION:
      return {...state, seleccion: payload}
    case SUSCRIPCION_TYPES.SUSCRIPCION_SET_DETALLE_PAGO:
      return {...state, detallePago: payload}
    case SUSCRIPCION_TYPES.SUSCRIPCION_SET_VALIDAR_SALDO:
      return {...state, validarSaldo: payload}
    case SUSCRIPCION_TYPES.SUSCRIPCION_CLEAR:
      return initialState
    default:
      return state
  }
}

export default suspcripcionReducer
